import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';
import { FormContainer } from 'components/styledComponents';

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  transform: `translateX(${theme.spacing(1)})`
}));

export const RoleWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.color.grey[400]}`,
  boxSizing: 'border-box',
  display: 'flex',
  [`& ${FormContainer}`]: {
    flexGrow: 1
  }
}));
